<script>
    import Icon from 'svelte-awesome';
    import bullhorn from "svelte-awesome/icons/bullhorn";
    import users from "svelte-awesome/icons/users";
    import filter from "svelte-awesome/icons/filter";
    import {goto} from "@sveltech/routify/runtime";

    const setCampaignGoal = (goal) => {

        $goto('/app/campaigns/' + goal);
    }

</script>

<div class="container">


    <h1 class="display-4">Doelstelling</h1>

    <p class="lead">Wat is het belangrijkste doel van je campagne voor dit event?</p>

    <div class="card" on:click={() => setCampaignGoal('branding')}>
        <div class="card-body bg-light text-dark">
            <div class="row">
                <div class="col-2">
                    <Icon data={bullhorn} scale="2"/>
                </div>
                <div class="col-10">
                    <h5>Meer naamsbekendheid</h5>
                    <p><small>Zorg er voor dat de doelgroep weet dat je event ingepland staat.</small></p>
                </div>
            </div>
        </div>
    </div>

    <div class="card" on:click={() => setCampaignGoal('engagement')}>
        <div class="card-body bg-light text-dark">
            <div class="row">
                <div class="col-2">
                    <Icon data={filter} scale="2"/>
                </div>
                <div class="col-10">
                    <h5>Creëer een betrokken doelgroep</h5>
                    <p><small>Bouw een doelgroep op met interesse voor je event.</small></p>
                </div>
            </div>
        </div>
    </div>

    <div class="card" on:click={() => setCampaignGoal('conversion')}>
        <div class="card-body bg-light text-dark">
            <div class="row">
                <div class="col-2">
                    <Icon data={users} scale="2"/>
                </div>
                <div class="col-10">
                    <h5>Meer bezoekers</h5>
                    <p><small>Activeer je doelgroep om een ticket voor je event te kopen of winnen.</small></p>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .card p {
        margin-bottom: 0px;
    }
</style>